import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { Button } from '@styles/shared-styles';
import { themeProvider } from '@swipejobs/frontend-theme-provider';
import styled, { css } from 'styled-components';

export const ReviewPageContainer = styled.div`

`;

export const CompletionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 150px;
  height: 150px;
  text-align: center;
  margin: 0 auto;
`;

export const CompletionText = styled.div`
  font-size: ${() => themeProvider.getTypography().font.size.extraLarge};
  font-weight: bold; 
  padding-top: 15px;
`;

export const CompletionIcon = styled(CheckCircleIcon)`
  color: ${() => themeProvider.getColors().general.greenDarkColor};
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 30px;
`;

export const DeclineButton = styled(Button)`
      background-color: ${() => themeProvider.getColors().text.primaryTextColor};
      border: ${() => themeProvider.getFraming().border.tiny};
      border-color: ${() => themeProvider.getColors().text.errorTextMessage};
      color: ${() => themeProvider.getColors().text.errorTextMessage};
`;

export const ESignButton = styled(Button)`
    background-color: ${() => themeProvider.getColors().general.greenDarkColor};
    color: ${() => themeProvider.getColors().text.primaryTextColor};
    margin-left: 30px;
`;

interface TitleProps {
    topSpacing?: boolean;
    bottomSpacing?: boolean;
    align?: React.CSSProperties['textAlign'];
}

export const Title = styled.div<TitleProps>`
  flex-direction: column;
  margin-top: ${props => props.topSpacing ? 30 : 10}px;
  margin-bottom: ${props => props.bottomSpacing ? 30 : 10}px;
  font-weight: bold;
  ${({ align }) => align && css`text-align: ${align}`};
`;

export const InstructionLine = styled.div`
  margin-top: 10px;
`;

export const AgreementTitle = styled.div`
  margin-bottom: 10px;
`;

export const RoundedContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  padding: 18px;
  border: 2px solid #000;
  border-radius: 8px;
`;

export const SpacedText = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const ErrorText = styled.div`
  text-align: center;
  color: ${() => themeProvider.getColors().text.errorTextMessage};
  font-weight: 600;
  margin-top: 10px;
`;

export const LeftAlign = styled.div`
  @media (max-width: 768px) {
    margin-top: 2px;
    margin-bottom: 2px;
  }
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: left;
`;



// WEBPACK FOOTER //
// ./src/screens/review-section3/review/styles.tsx